import React, { Component, Fragment } from 'react'
import { Route, Redirect, Switch, withRouter } from "react-router-dom"
import Home from './Home'
import Login from './Login2'
import Footer from './Footer'
import IPTV from './IPTV'
import Payments from './Payments'
import PaymentHistory from './PaymentHistory'
import PaymentResult from './PaymentResult'
import TAT from './TAT'
import WIFI from './WIFI'
import Bills from './Bills'
import MD5 from 'md5'
import MyMenu from './MyMenu'
import ForceUpdate from './ForceUpdate'
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { withStyles } from '@mui/styles';


import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  CircularProgress
} from '@mui/material'

// const mainURL = "https://fslab.massycommunications.com:8443";
const mainURL = "https://accountapi.amplia.co.tt";

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
}

const theme = createTheme({
  palette: {
    background: {
      default: '#999999',
      paper: '#55565A'
    },
    //color: 'white',
    text: {
      primary: "rgba(255, 255, 255, 1)",
      secondary: "rgba(255, 255, 255, 1)",
    },
    primary1Color: '#55565A',
  },
  typography: {
    fontFamily: ['Sans-Serif'],
  },
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          background: 'transparent',
        },
        paper: {
          background: 'transparent',
          boxShadow: 'none'
        }
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          background: 'transparent'
        },
        paper: {
          background: 'transparent',
          //boxShadow: 'none'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: 'white'
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: 'white'
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          background: '#55565A',
          color: 'rgba(71, 237, 62, 1)'
        },
        expanded: {
          background: 'rgba(71, 237, 62, 1)',
          color: '#55565A'
        },
        gutters: {
          color: 'white'
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          background: 'white',
        },
      }
    },
  },


});

const styles = theme => ({
  dialogPaper: {
    boxShadow: 'none',
    overflow: 'hidden',
    background: 'transparent'
  }
});

class App extends Component {
  state = {
    loggedIn: false,
    loginInfo: null,
    token: null,
    currentpass: null,
    openAlert: false,
    alertMessage: '',
    spinner: false,
    wifi: [],
    iptv: [],
    tats: [],
    ads: [],
    bills: [],
    payments: [],
    balance: 0,
    paymentResult: {
      transactionSuccess: false,
      reference: "---",
      facError: " "
    }
  }
  handleAlertClose = () => {
    this.setState({
      openAlert: false
    });
  };

  checkResult = (result, message) => {
    switch (result) {
      case 'loggedoff':
        this.setState({ loggedIn: false })
        console.log("user has been logged off")
        //alert("Logged off")
        return false
      case 'error':
        console.log("transaction came with error")
        console.log(message)
        return false

      default: return true
    }
  }

  submitPayment = async (form) => {

    // this.setState({
    //   spinner: true,
    // });
    try {
      const req = await (await fetch(mainURL + '/ampliaSS2', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: "sale3DS2",
          token: this.state.token,
          username: this.state.loginInfo.username,
          "cardNumber": form.cardNumber,
          "expiry": form.expiry,
          "cvv": form.cvv,
          "ammount": form.amount,
          "firstName": form.firstName,
          "lastName": form.lastName,
          "streetAddress": form.streetAddress,
          "country": form.country
        })
      })).json()
      if (req.result === "ok") {

        //submit form to bank on new window
        var newWin = window.open('', 'SubmitPayment', 'height=400,width=600');
        
        const orderId = req.orderId
        newWin.document.write(req.html)
        //loop check for result
        for (let index = 0; index < 40; index++) {
          this.sleep(3000)
          const payres = await (await fetch(mainURL + '/ampliaSS2', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: "paymentLocalDetail",
              token: this.state.token,
              username: this.state.loginInfo.username,
              "orderId": orderId,
            })
          })).json()

          if (payres.result === "ok" && payres.transaction.fac_reasonCode === 1) {
            newWin.close()
            this.setState({
              spinner: false,
            });
            this.setState({
              paymentResult: {
                spinner: false,
                transactionSuccess: true,
                reference: orderId,
                facError: "",
                crmnumber: this.state.loginInfo.username,
                amount: form.amount
              }
            })
            this.props.history.push('/paymentresult')
            break
          } else if (payres.result === "ok" && payres.transaction.fac_reasonCode > 1) {
            newWin.close()
            this.setState({
              spinner: false,
            });
            this.setState({
              paymentResult: {
                spinner: false,
                transactionSuccess: false,
                reference: orderId,
                facError: payres.transaction.fac_reasonCodeDescription,
                crmnumber: this.state.loginInfo.username,
                amount: form.amount
              }
            })
            this.props.history.push('/paymentresult')
            break
          }


        }



      } else {
        this.setState({
          spinner: false,
        });
        this.setState({
          paymentResult: {
            transactionSuccess: false,
            reference: "---",
            facError: "Internal Error",
            crmnumber: this.state.loginInfo.username,
            amount: form.amount
          }
        })
        this.props.history.push('/paymentresult')
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        paymentResult: {
          transactionSuccess: false,
          reference: "---",
          facError: "Connection Lost",
          crmnumber: this.state.loginInfo.username,
          amount: form.amount
        }
      })
      this.props.history.push('/paymentresult')
    }
  }

  sleep = (milliseconds) => {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

  getIPTV = async () => {
    try {
      this.setState({
        spinner: true,
      });
      const req = await (await fetch(mainURL + '/getDLOIPTV', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: this.state.token, username: this.state.loginInfo.username })
      })).json()
      this.setState({
        spinner: false,
      });
      if (this.checkResult(req.result, req.message)) {
        const iptv = req.iptv
        this.setState({ iptv })
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  removeIPTV = async (uuid) => {
    this.setState({
      spinner: true,
    });
    try {
      const req = await (await fetch(mainURL + '/deleteDLOSTB', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: this.state.token, uuid: uuid })
      })).json()
      this.setState({
        spinner: false,
      });
      if (req.result === "ok") {
        this.setState({
          openAlert: true,
          alertMessage: "IPTV device removed"
        });
        this.getIPTV()
      } else {
        this.setState({
          openAlert: true,
          alertMessage: "There was an error removing device. Please, try again."
        });
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  getDLOWiFi = async () => {
    this.setState({
      spinner: true,
    });
    try {
      const req = await (await fetch(mainURL + '/getDLOWiFi', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: this.state.token, username: this.state.loginInfo.username })
      })).json()
      this.setState({
        spinner: false,
      });
      if (this.checkResult(req.result, req.message)) {
        const wifi = req.wifi
        this.setState({ wifi })
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  updateWiFiSSID = async (index, ssid) => {
    this.setState({
      spinner: true,
    });
    try {
      const req = await (await fetch(mainURL + '/updateWifi', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: this.state.token,
          username: this.state.loginInfo.username,
          radio: index,
          parameter: "SSID",
          value: ssid
        })
      })).json()
      this.setState({
        spinner: false,
      });
      if (req.result === "ok") {
        //this.updateWiFiPassword(index, password)
        this.getDLOWiFi()
      } else {
        this.setState({
          openAlert: true,
          alertMessage: "There was an error updating the WiFi. Please, try again."
        });
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  updateWiFiPassword = async (index, password) => {
    this.setState({
      spinner: true,
    });
    try {
      this.setState({
        spinner: true,
      });
      const req = await (await fetch(mainURL + '/updateWifi', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: this.state.token,
          username: this.state.loginInfo.username,
          radio: index,
          parameter: "password",
          value: password
        })
      })).json()
      if (req.result === "ok") {
        // this.setState({
        //   openAlert: true,
        //   alertMessage: "WiFi updated"
        // });
        this.getDLOWiFi()
      } else {
        this.setState({
          openAlert: true,
          alertMessage: "There was an error updating the WiFi. Please, try again."
        });
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  downloadBill = async (bill) => {
    this.setState({
      spinner: true,
    });
    try {
      this.setState({
        spinner: true,
      });
      const req = await (await fetch(mainURL + '/viewInvoice', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: this.state.token,
          username: this.state.loginInfo.username,
          filename: bill
        })
      })).json()
      this.setState({
        spinner: false,
      });
      if (req.result === "ok") {

        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var blob = b64toBlob(req.pdf, "application/pdf");
        // var newBlob = new Blob([window.atob(req.pdf)], {
        //   type: "application/pdf"
        // })

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
          return;
        }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = data;
        link.download = bill;
        link.click();
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data)
        }
          , 100)



      } else {
        this.setState({
          openAlert: true,
          alertMessage: "There was an error retrieving your invoice."
        });
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  getTT = async () => {
    this.setState({
      spinner: true,
    });
    try {
      const req = await (await fetch(mainURL + '/getTT', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: this.state.token, username: this.state.loginInfo.username })
      })).json()
      this.setState({
        spinner: false,
      });
      if (this.checkResult(req.result, req.message)) {
        const tats = req.tts
        this.setState({ tats })
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  getAds = async () => {
    this.setState({
      spinner: true,
    });
    try {
      const req = await (await fetch(mainURL + '/getAd', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: this.state.token, username: this.state.loginInfo.username })
      })).json()
      this.setState({
        spinner: false,
      });
      if (this.checkResult(req.result, req.message)) {
        const ads = req.images
        this.setState({ ads })
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  getBills = async () => {
    this.setState({
      spinner: true,
    });
    try {
      const req = await (await fetch(mainURL + '/getInvoices', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: this.state.token,
          username: this.state.loginInfo.username
        })
      })).json()
      this.setState({
        spinner: false,
      });
      if (this.checkResult(req.result, req.message)) {
        const bills = req.invoices.slice(0, 6)
        this.setState({
          bills
        })
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }
  getPayments = async () => {
    this.setState({
      spinner: true,
    });
    try {
      const req = await (await fetch(mainURL + '/getPayments', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: this.state.token,
          username: this.state.loginInfo.username
        })
      })).json()
      this.setState({
        spinner: false,
      });
      if (this.checkResult(req.result, req.message)) {
        const payments = req.payments.slice(0, 6)
        this.setState({
          payments
        })
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  getBalance = async () => {
    this.setState({
      spinner: true,
    });
    try {
      const req = await (await fetch(mainURL + '/getOustanding', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: this.state.token,
          username: this.state.loginInfo.username,
          accountNumber: this.state.loginInfo.username
        })
      })).json()
      this.setState({
        spinner: false,
      });
      if (this.checkResult(req.result, req.message)) {
        const balance = req.ous[0].amount
        this.setState({
          balance
        })
      }
    } catch (error) {
      this.setState({
        spinner: false,
      });
      console.log(error);
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  logout = async () => {
    this.setState({
      spinner: true,
    });
    try {
      const logout = await (await fetch(mainURL + '/logout', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: this.state.token,
          username: this.state.loginInfo.username
        })
      })).json()
      this.setState({
        spinner: false,
      });
      if (logout.loggedOut) {
        this.props.history.push('/')
        this.setState({ loginInfo: null, loggedIn: false })

      }
    } catch (err) {
      this.setState({
        spinner: false,
      });
      console.log(err)
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  forgotPass = async (username) => {
    this.setState({
      spinner: true,
    });
    try {
      await (await fetch(mainURL + '/forgotPassword', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: username
        })
      })).json()
      this.setState({
        spinner: false,
      });
      this.setState({
        openAlert: true,
        alertMessage: "We sent an email with instructions to reset your password. Please, check your inbox."
      });
    } catch (err) {
      this.setState({
        spinner: false,
      });
      console.log(err)
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }
  forgotPassSMS = async (username, last4) => {
    console.log(last4)
    this.setState({
      spinner: true,
    });
    try {
      await (await fetch(mainURL + '/forgotPassword', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: username,
          recoveryMode: "SMS",
          last4: last4
        })
      })).json()
      this.setState({
        spinner: false,
      });
      this.setState({
        openAlert: true,
        alertMessage: "We sent an SMS with instructions to reset your password. Please, check your mobile phone."
      });
    } catch (err) {
      this.setState({
        spinner: false,
      });
      console.log(err)
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  changePass = async (newpass) => {
    this.setState({
      spinner: true,
    });
    try {
      const login = await (await fetch(mainURL + '/updatePassword', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: this.state.loginInfo.username,
          // currentPassword: this.state.currentpass,
          token: this.state.token,
          newPassword: MD5(newpass)
        })
      })).json()
      this.setState({
        spinner: false,
      });
      if (login.result === "ok") {
        this.setState({ loggedIn: true })
        this.loader()
        this.props.history.push('/')

      } else {
        this.setState({
          openAlert: true,
          alertMessage: "Change password attempt failed. Please, try again."
        });
      }
    } catch (err) {
      this.setState({
        spinner: false,
      });
      console.log(err)
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  login = async (user, pass) => {
    this.setState({
      spinner: true,
    });
    try {
      const login = await (await fetch(mainURL + '/login', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: user,
          password: MD5(pass)
        })
      })).json()
      this.setState({
        spinner: false,
      });
      if (login.loggedIn) {
        if (login.user.forceUpdate) {
          this.setState({
            loginInfo: login.user,
            loggedIn: false,
            truetoken: login.token,
            token: login.token,
            currentpass: MD5(pass)
          })
          this.props.history.push('/updatepass')
          this.loader()
        } else {
          this.setState({
            loginInfo: login.user,
            loggedIn: true,
            token: login.token
          })
          this.loader()
        }
      } else {
        this.setState({
          openAlert: true,
          alertMessage: "Login attempt failed. Please, review your credentials and try again."
        });
      }
    } catch (err) {
      this.setState({
        spinner: false,
      });
      console.log(err)
      this.setState({
        openAlert: true,
        alertMessage: "Network error. Please, try again."
      });
    }
  }

  loader = async () => {

    await this.getIPTV()
    await this.getDLOWiFi()
    await this.getTT()
    await this.getAds()
    await this.getBills()
    await this.getPayments()
    await this.getBalance()
  }


  render() {
    const { wifi } = this.state
    const { iptv } = this.state
    const { tats } = this.state
    const { ads } = this.state
    const { loginInfo } = this.state
    const { bills } = this.state
    const { payments } = this.state
    const { balance } = this.state
    const { paymentResult } = this.state
//    const { classes } = this.props
    return (
      <ThemeProvider theme={theme}>
        < CssBaseline />
        <Fragment>
          {this.state.loggedIn ? <MyMenu name={this.state.loginInfo.firstName} logout={this.logout} /> : <Redirect to="/" />}
          <Switch>
            <Route exact path="/" render={() => this.state.loggedIn ? <Home /> : <Login doLogin={this.login} forgotPass={this.forgotPass} forgotPassSMS={this.forgotPassSMS} />} />
            <Route path="/updatepass" render={() => <ForceUpdate changepass={this.changePass} />} />
            <Route path="/iptv" render={() => <IPTV iptv={iptv} reload={this.getDLOIPTV} remove={this.removeIPTV} />} />
            <Route path="/wifi" render={() => <WIFI wifi={wifi} reload={this.getDLOWiFi} updateWiFiName={this.updateWiFiSSID} updateWiFiPassword={this.updateWiFiPassword} />} />
            <Route path="/tat" render={() => <TAT tats={tats} reload={this.getTT} />} />
            <Route path="/invoices" render={() => <Bills bills={bills} downloadBill={this.downloadBill} balance={balance} />} />
            <Route path="/payments" render={() => <PaymentHistory bills={bills} payments={payments} downloadBill={this.downloadBill} balance={balance} />} />
            <Route path="/payment" render={() => <Payments submitPayment={this.submitPayment} balance={balance} loginInfo={loginInfo} />} />
            <Route path="/paymentresult" render={() => <PaymentResult paymentResult={paymentResult} />} />
          </Switch>
          {this.state.loggedIn ? <Footer ads={ads} /> : null}

          <Dialog
            open={
              this.state.openAlert
            }
            PaperProps={{ sx: { background: '#55565A' } }}
            // sx={
            //   { background: '#999999' }
            // }
            onClose={this.handleAlertClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.state.alertMessage}

              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleAlertClose} style={{ color: 'white' }} autoFocus>
                OK
              </Button>

            </DialogActions>

          </Dialog>
          <Dialog
            open={this.state.spinner}
            PaperProps={{ sx: { boxShadow: 'none',overflow: "hidden" } }}
            scroll='body'
            sx={{
              backgroundColor: 'transparent',
              //top: '50%',
              width: '100%',
              margin: 'auto',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              background: 'transparent'
            }}
          >
            <CircularProgress
              overflow='hidden'
              sx={{
                color: 'rgba(71,237,62,1)',
                // width: 10,
                // height: 10,
                overflow: "hidden",
                background: 'transparent',

              }}
              size={60}
              thickness={3} />
          </Dialog>


        </Fragment>

      </ThemeProvider>
    )
  }
}

export default withRouter(withStyles(styles)(App))